import useLoadContentResults from './useLoadContentResults';

const usePrepareContentItem = () => {
  const { getNewResult, enrichContentWithKeywords, highlightContent } = useLoadContentResults({});

  const prepareContentItem = async ({
    source,
    nameSection,
    path,
    propType,
    propId,
    content,
    enrich = true,
    highlightOptions,
  }) => {
    const fetchedResult =
      content ??
      (await getNewResult({
        source,
        nameSection,
        path,
        propType,
        propId,
      }));

    if (!fetchedResult) {
      return null;
    }

    let preparedResult = { ...fetchedResult };

    if (enrich) {
      preparedResult = await enrichContentWithKeywords({ content: preparedResult });
    }

    if (highlightOptions?.enabled) {
      preparedResult = await highlightContent({
        content: preparedResult,
        source,
        forceHighlight: true,
        ...highlightOptions?.props,
      });
    }

    return preparedResult;
  };

  return { prepareContentItem };
};

export default usePrepareContentItem;
